import React from 'react'

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Article from 'pages/Article'
import Support from 'pages/Support'
import ErrorPage from 'pages/Error'
import { ARTICLES, HOME, SUPPORT, UB_SUPPORT } from 'config/routes'
import { AppInfoContextProvider } from 'contexts/AppInfoContext'
import { AppContext, AppLanguage } from 'config/enums'
import { getContext, getLanguage, getTheme } from 'utils/helpers'
import { UbSupportPage } from 'pages/UbSupportPage/UbSupportPage'

import { initTheme, Theme } from '@interco/inter-ui'
import { interWbSession } from '@interco/inter-webview-bridge'

type AppInfo = {
  context: AppContext
  language: AppLanguage
}

function App() {
  const [appInfo, setAppInfo] = React.useState<AppInfo>()

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)

    const orgQueryParam = urlParams.get('org')

    interWbSession
      .getAppInfo()
      .then((iWbAppInfo) => {
        const { application, organization, language: appLanguage, isDarkMode } = iWbAppInfo

        const context = getContext(organization, orgQueryParam)
        const language = getLanguage(context, appLanguage)
        const theme = getTheme(application)

        initTheme(theme, !!isDarkMode)
        setAppInfo({ context, language })
      })
      .catch(() => {
        const context = getContext(AppContext.PF, orgQueryParam)

        initTheme(Theme.PF, false)
        setAppInfo({ context, language: AppLanguage.PT })
      })
  }, [])

  return appInfo ? (
    <AppInfoContextProvider {...appInfo}>
      <Router>
        <Routes>
          <Route path="*" element={<ErrorPage />} />
          <Route path={HOME}>
            <Route path={ARTICLES}>
              <Route path=":articleId" element={<Article />} />
            </Route>
            <Route path={SUPPORT} element={<Support />} />

            <Route path={UB_SUPPORT} element={<UbSupportPage />} />
          </Route>
        </Routes>
      </Router>
    </AppInfoContextProvider>
  ) : null
}

export default App
